import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TicketList from "./tabItems/TicketList";
import AddTicket from "./tabItems/AddTicket";
import { setTicket } from "../../store/slices/ticketSlice";

export const ticketTabConfig = {
    LIST: "1",
    ADD: "2"
}

const TicketTab = () => {
    const [currentTab, setCurrentTab] = useState(ticketTabConfig.LIST);
    const [tabTada, setTabData] = useState({});
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(setTicket({}));
    }, [])

    const onSwitchTab = (key, data) => {
        setCurrentTab(key);
    } 

    const tabs = [
        {
          key: ticketTabConfig.LIST,
          label: 'Tickets',
          children: <TicketList onSwitchTab={onSwitchTab} />,
        },
        {
            key: ticketTabConfig.ADD,
            label: 'Add / Modify Ticket',
            children: <AddTicket onSwitchTab={onSwitchTab} tabProps={{}} />,
        }
    ];

    const onChange = (key) => {
        setCurrentTab(key);
        if (key !== ticketTabConfig.ADD) {
            dispatch(setTicket({}));
        }
    };

    return (
        <div>
            <div className="text-2xl pb-3">Tickets</div>
            <div className="px-4 border pb-6 bg-white pop-left">
                <Tabs defaultActiveKey="1" activeKey={currentTab} items={tabs} onChange={onChange} />
            </div>
        </div>
    )
}

export default TicketTab;